import {useCombatants} from "@/encounter/combatants/CombatantHooks.ts";
import CharacterAvatar from "@/characters/CharacterAvatar.tsx";
import {Separator} from "@/components/ui/separator.tsx";
import {Button} from "@/components/ui/button.tsx";
import {Eye, EyeOff, Heart, Trash2} from "lucide-react";
import {ButtonGroup, ButtonGroupSeparator} from "@/components/ui/button-group.tsx";
import {cn} from "@/lib/utils.ts";
import DeleteConfirm from "@/components/forms/DeleteConfirm.tsx";
import {useTableTopSelection} from "@/tabletop/selection/TableTopSelectionHooks.ts";


export default function MultiCombatantOptions() {

    const {update, remove} = useCombatants()
    const {selectedCombatants, selectCombatants, clearSelection} = useTableTopSelection()

    const removeSelectedCombatants = () => {
        void remove(selectedCombatants);
        clearSelection();
    };


    return (
        <div className="flex flex-col h-full overflow-y-auto">
            <div className="flex flex-col bg-gray-950 p-2 gap-3 min-h-min ">
                {/* Buttons */}
                <div>
                    <div className="flex flex-row items-center justify-between">
                        <ButtonGroup>
                            <Button className="text-white bg-amber-700 hover:bg-amber-600"
                                    title="Anzeigen" type="button" size="icon-sm"
                                    onClick={() => update(selectedCombatants
                                        .map(combatant => ({...combatant, hidden: false})))}>
                                <Eye/>
                            </Button>
                            <ButtonGroupSeparator/>
                            <Button className="text-white bg-amber-700 hover:bg-amber-600"
                                    title="Verbergen" type="button" size="icon-sm"
                                    onClick={() => update(selectedCombatants
                                        .map(combatant => ({...combatant, hidden: true})))}>
                                <EyeOff/>
                            </Button>
                        </ButtonGroup>


                        <DeleteConfirm
                            title="Ausgewählte Charaktere löschen?" onConfirm={removeSelectedCombatants}>
                            <Button className="text-white bg-rose-800 hover:bg-rose-600" title="Löschen"
                                    type="button" size="icon-sm">
                                <Trash2/>
                            </Button>
                        </DeleteConfirm>
                    </div>
                </div>
                <Separator/>
                {/* Combatants */}
                <div className="flex flex-col gap-0.5 text-sm">
                    {selectedCombatants.map(combatant =>
                        <div key={combatant.id}
                             onClick={() => selectCombatants([combatant])}
                             className={cn("flex flex-row items-center px-0.5 gap-2 border rounded-xs cursor-pointer",
                                 combatant.hostile ?
                                     "bg-hostile-dark hover:bg-hostile"
                                     : "bg-friendly-dark hover:bg-friendly")}>
                            <CharacterAvatar className="rounded-xs" combatant={combatant} size={28}/>
                            <div className="grow truncate">{combatant.name}</div>
                            <div className="flex flex-row items-center gap-1 text-nowrap">
                                <Heart size={14}/>{combatant.currentLife}/{combatant.maxLife}
                            </div>
                        </div>)}
                </div>

            </div>
        </div>)

}
